import { Component, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { InitialDataService } from 'src/app/services/initialData.service';
import { TenantConfService } from 'src/app/services/tenant-conf.service';
import { constants } from '@syntonize/merlin-core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  scrollPosition;

  brand = {
    name: 'Brand',
    logoPath: '../../assets/images/logo.png',
  };

  languageSelectorOptions: any = {
    translucent: true,
  };

  language: string;
  availableLanguages;
  isVisible = false;
  tenantLogo$;

  constructor(
    private menu: MenuController,
    private initialData: InitialDataService,
    private tenantService: TenantConfService,
    private translateService: TranslateService
  ) {
    try {
      this.scrollPosition = scrollY;
    } catch (err) {
      this.scrollPosition = 0;
    }
  }

  ngOnInit() {
    const al = this.tenantService.getTenantAvailableLanguages();
    this.availableLanguages = al;
    this.language = this.tenantService.getLanguage();

    this.isVisible = false;
    setTimeout(() => {
      this.isVisible = true;
    }, 1000);

    this.tenantLogo$ = this.initialData.logo$;
  }

  async useLanguage(language: string) {
    if (!this.language || !language || language === this.language) {
      return;
    }

    localStorage.setItem(constants.storage.language, language.toLowerCase());

    await this.translateService.use(language).toPromise();
    location.pathname = [
      language,
      ...location.pathname
        .split('/')
        .slice(2)
        .map((path, index) => (index === 0 && path !== undefined ? this.translateService.instant('ROUTES.' + path.toUpperCase()) : path)),
    ].join('/');
  }
  openMenu() {
    this.menu.enable(true, 'sidebar');
    this.menu.open('sidebar');
  }
}
